import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const Processus = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  const renderIcon = (iconType, index) => {
    const iconProps = { width: "35", height: "35", fill: "#4CAF50" };
    
    const icons = {
      0: ( // Rendez-vous
        <svg {...iconProps} viewBox="0 0 24 24">
          <path d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z"/>
        </svg>
      ),
      1: ( // Simulation
        <svg {...iconProps} viewBox="0 0 24 24">
          <path d="M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M13,13H18V16H13V13M13,9H18V12H13V9M13,5H18V8H13V5M10,7H6V10H10V7M10,11H6V14H10V11M10,15H6V18H10V15Z"/>
        </svg>
      ),
      2: ( // Comparaison
        <svg {...iconProps} viewBox="0 0 24 24">
          <path d="M22,21H2V3H4V19H6V17H10V19H12V16H16V19H18V15H22V21M16,8H18V13H16V8M12,2H14V13H12V2M6,10H8V13H6V10Z"/>
        </svg>
      ),
      3: ( // Changement
        <svg {...iconProps} viewBox="0 0 24 24">
          <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
        </svg>
      )
    };
    
    return icons[index] || icons[0];
  };

  useEffect(() => {
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('visible');
          observer.disconnect();
        }
      }, { threshold: 0.2 });
      
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
      
      return () => observer.disconnect();
    }
  }, []);

  const steps = [
    {
      number: "01",
      title: t('processus.step1.title'),
      description: t('processus.step1.description'),
      icon: "calendar"
    },
    {
      number: "02",
      title: t('processus.step2.title'),
      description: t('processus.step2.description'),
      icon: "calendar"
    },
    {
      number: "03",
      title: t('processus.step3.title'),
      description: t('processus.step3.description'),
      icon: "calendar"
    },
    {
      number: "04",
      title: t('processus.step4.title'),
      description: t('processus.step4.description'),
      icon: "calendar"
    }
  ];

  return (
    <section className="processus section-animate" id="processus" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title title-animate">{t('processus.title')}</h2>
          <p className="section-subtitle subtitle-animate">
            {t('processus.subtitle')}
          </p>
        </div>
        
        <div className="processus-timeline">
          {steps.map((step, index) => (
            <div key={index} className="processus-step stagger-item">
              <div className="step-number">{step.number}</div>
              <div className="step-icon">
                {renderIcon(step.icon, index)}
              </div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="step-connector"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Processus; 